<template>
  <v-layout>
    <v-app-bar app clipped-left color="primary" dark>
      <v-toolbar-title>Delivery</v-toolbar-title>
      <v-spacer></v-spacer>
      <div v-if="user">
        <span class="mr-4">{{ user.fullname }}</span>
        <v-btn @click="logout">Выход</v-btn>
      </div>
    </v-app-bar>
    <Drawer v-if="user"/>
    <Toast/>
    <v-main :style="`padding: ${user ? mainPadding : 0}`">
      <v-container fluid class="fill-height">
        <v-toolbar v-if="user" outlined style="position: sticky; top: 62px; margin-bottom: 8px; 
         z-index: 3" elevation="2">
          <v-toolbar-title>
            <span id="settings-group-header"></span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <div id="settings-group-actions"></div>    
        </v-toolbar>
        <slot name="content"></slot>
      </v-container>
    </v-main>
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex';
import Toast from '@/components/ui/Toast.vue';
import Drawer from '@/components/ui/Drawer.vue';

export default{

  computed: {
    user(){
      return this.$store.getters.user
    },

    mainPadding() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        return '64px 0 0 256px'
      } else {
        return '64px 0 0 56px'
      }
    }
  },

  methods: {
    ...mapActions(['logout'])
  },

  components:{
    Toast,
    Drawer
  }
}
</script>
